module.exports = __webpack_public_path__ + "static/media/mainlogo.5dea9d18.png";